import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
export const TabContainer = (props) => {
	const [showModal, setShowModal] = useState(false);
	const onOptionSelect = (item) => {
		if (props.showImage && item.tipMaterialCode === props.defaultColor) {
			props.onItemSelect('', '', '');
		} else {
			props.onItemSelect(
				item[props.keyNames.defaultColor],
				item.colorId || `${item.imagePath + item.tipMaterialCode + '-lg.png'}`,
				item.renderColorName || item.tipMaterialName,
				item[props.keyNames.webColor] || null
			);
		}
	};
	return (
		<>
			<div className='title_div'>
				{props.title}
				{props.upchargeAmt && (
					<>
						{' '}
						<span>(ADD FOR ${props.upchargeAmt}.00)</span>
						&nbsp;
						<span>
							<i
								id='infoIcon'
								className='fas fa-info-circle'
								onClick={() => setShowModal(true)}></i>
						</span>
					</>
				)}
			</div>
			<div className='description_div'>{props.description}</div>
			<div className='branding_div'>
				{props.displayItemList &&
					props.displayItemList.map((item, index) => (
						<div
							className={`item_wraper_div`}
							onClick={() => onOptionSelect(item)}
							key={index}>
							{props.showImage ? (
								<div className='image_div'>
									{(item.imagePath && item.tipMaterialCode) && 
									<img
										className={`items_div ${
											item.tipMaterialCode === props.defaultColor
												? 'selected_color_div'
												: ''
										}`}
										src={
											process.env.REACT_APP_JOSTENS_CDN_HOST +
											item.imagePath +
											item.tipMaterialCode +
											'-sm.png'
										}
										alt={item.tipMaterialName}
									/>
                                }
									{item.tipMaterialCode === props.defaultColor ? (
										<div className='select_icon'>
											<i className='tick'></i>
										</div>
									) : (
										''
									)}
								</div>
							) : (
								<div
									className={`items_div ${
										item.colorId === props.defaultColor
											? 'selected_color_div'
											: ''
									}`}
									style={{
										backgroundColor: '#' + item[props.keyNames.backgroundColor],
									}}>
									{item.colorId === props.defaultColor ? (
										<div className='select_icon'>
											<i className='tick'></i>
										</div>
									) : (
										''
									)}
								</div>
							)}
							<p className='color_name'>
								{item.consumerColorName || item.tipMaterialName}
							</p>
						</div>
					))}
			</div>
			<Modal
				id='modal'
				onHide={() => setShowModal(false)}
				show={showModal}
				dialogClassName='modal-lg'
				backdrop='static'
				keyboard={false}>
				<Modal.Header id='modalHeader' closeButton>
          <h4>
					{props.stoleMeta &&
						props.stoleMeta.header &&
						props.stoleMeta.header.tipsToolTipHeader}
					</h4>
        </Modal.Header>
				<Modal.Body>
					{props.stoleMeta &&
						props.stoleMeta.header &&
						props.stoleMeta.header.tipsToolTip}
				</Modal.Body>
        <Modal.Footer></Modal.Footer>
			</Modal>
		</>
	);
};
